<template>
  <div class="block pt-6 current-product" :class="{'pb-10': !product}">
    <!-- Content -->
    <div class="mx-auto block max-w-2k">
      <!-- Breadcrumb -->
      <Breadcrumb :items="breadcrumbItems" class="mb-10"/>
      <!-- Product Name -->
      <span class="font-extrabold text-2xl">{{ name }}</span>
    </div>

    <!-- Navigation -->

    <ul class="mx-auto flex items-center max-w-2k mt-10 gap-5 sub-sections" v-if="product">
      <li :class="{'active': !isInFaqSection}">
        <nuxt-link :to="localePath(`/products/${customerType}/${product.slug}/kb/about-${product.slug}?section=getting-started`)">
          {{ $t('online_help') }}
        </nuxt-link>
      </li>

      <li :class="{'active': isInFaqSection}">
        <nuxt-link :to="localePath(`/products/${customerType}/${product.slug}/faqs`)">
          {{ $t('faqs') }}
        </nuxt-link>
      </li>
    </ul>
  </div>
</template>
<script lang="ts" setup>
import type { PropType } from 'vue';
import { useProductStore } from '~/store/product';
import { useSupportSectionsStore } from '~/store/support';

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  breadcrumbItems: {
    type: Array as PropType<Array<{ title: string, path?: string }>>,
    required: false,
    default: () => null,
  }
});

const { t } = useI18n();
const route = useRoute();
const localePath = useLocalePath();
const customerType = computed(() => route.params.customerType);


const productStore = useProductStore();
const articleStore = useSupportSectionsStore();
const { product } = storeToRefs(productStore);
const { article } = storeToRefs(articleStore);

const isInFaqSection = computed(() => route.path.endsWith('/faqs'));

const breadcrumbItems = computed(() => {
  if (props.breadcrumbItems !== null) {
    return props.breadcrumbItems;
  }

  return [
    { title: t("support"), path: localePath("/") },
    { title: t("support_for_home"), path: localePath("/") },
    { title: product.value?.name, path: localePath(`/products/${customerType.value}/${product.value?.slug}/kb/about-${product.value?.slug}?section=getting-started`) },
    { title: article.value?.title },
  ];
});
</script>
<style lang="scss" scoped>
.current-product {
  background-color: #CDDCE9;
}

ul {
  li {
    padding: 16px 0;
    border-bottom: 4px solid transparent;

    a {
      color: inherit;

      &:hover {
        color: var(--nv-theme-primary-dark);
      }
    }

    &.active {
      border-bottom: 4px solid var(--nv-theme-primary);
    }
  }
}
</style>